import * as Sentry from '@sentry/react';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnvironment = process.env.REACT_APP_ENVIRONMENT || 'development';

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ['error'] }),
    ],
    enableLogs: true,
    release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA,
  });
}

export function setSentryUser(user?: {
  userId: string;
  nickname?: string;
  clientId?: string;
  accountId?: number;
  organizationId?: number | null;
}) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.userId,
    username: user.nickname,
  });
  if (user.clientId) {
    Sentry.setTag('clientId', user.clientId);
  }
  if (user.accountId !== undefined) {
    Sentry.setTag('account.id', String(user.accountId));
  }
  Sentry.setTag(
    'organization.id',
    user.organizationId != null ? String(user.organizationId) : 'global',
  );
}
